import React from "react"
import classNames from 'classnames'
import { StyledHeaderLink } from './headerLink.styles'

export default function HeaderLink({
  active,
  display,
  className,
  ...props
}) {

  return (
    <StyledHeaderLink
      variant="text"
      className={classNames('link', className, { active })}
      key={props.href}
      {...props}
    >
      {display}
    </StyledHeaderLink>
  )
}